import { FormControl, FormHelperText, Grid2, InputLabel, OutlinedInput } from '@mui/material';
import type { FC, HTMLInputTypeAttribute } from 'react';

interface InputFormControlProps {
  label: string;
  id: string;
  registerProps: any;
  defaultValue?: string | undefined;
  error?: string | null;
  Grid?: number;
  type?: HTMLInputTypeAttribute;
  fullWidth?: boolean;
  placeholder?: string;
  variant?: 'outlined' | 'standard' | 'filled';
}

export const InputFormControl: FC<InputFormControlProps> = ({
  label,
  id,
  registerProps,
  defaultValue,
  error,
  Grid,
  fullWidth = false,
  type = 'text',
  variant = 'outlined'
}) => {
  const controlElement = (
    <FormControl fullWidth={fullWidth} variant={variant}>
      <InputLabel htmlFor={id} size="small">
        {label}
      </InputLabel>
      <OutlinedInput
        id={id}
        {...registerProps}
        error={!!error}
        label={label}
        autoComplete="off"
        defaultValue={defaultValue}
        type={type}
        variant={variant}
        size="small"
        color="primary"
      />
      {error && (
        <FormHelperText error id={`helper-text-${id}`}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );

  return Grid ? <Grid2 size={{ xs: Grid }}>{controlElement}</Grid2> : controlElement;
};
